import { memo, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { Marker } from "react-mapbox-gl";
import { Grid } from "@mui/material";

import { palette } from "../../../theme/palette";

import {
  heatmapViewSelector,
  selectedOverlaySelector,
} from "../../../reducers/matrixProfile/selectors";

import { RouteLabel } from "./RouteLabel";
import { LocationVolumes } from "./LocationVolumes";
import { View } from "../../View";

const useStyles = makeStyles({
  marker: {
    pointerEvents: "none",
    paddingBottom: "10px",
    display: "flex",
    flexDirection: "column",
  },
  container: {
    maxWidth: "86px",
    minWidth: "30px",
    minHeight: "30px",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
  },
  arrowContainer: {
    display: "flex",
    justifyContent: "center",
  },
  arrow: {
    width: "0",
    height: "0",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "10px solid white",
  },
  space: {
    width: "10px",
  },
  spacing: {
    padding: "2px",
  },
  routeLabelContainer: {
    height: "26px",
  },
});

export const RouteMarker = memo(({ location, showArrow = true }) => {
  const isVolumeOverlayOn = useSelector(selectedOverlaySelector);
  const isHeatmapOn = useSelector(heatmapViewSelector);
  const styles = useStyles();

  const { latitude, longitude, locationCode, routeCode } = location;

  const showVolume = useCallback(
    () => isVolumeOverlayOn && !isHeatmapOn,
    [isHeatmapOn, isVolumeOverlayOn]
  );

  return (
    <Marker
      className={styles.marker}
      coordinates={{
        lat: latitude,
        lng: longitude,
      }}
      anchor={"bottom"}
    >
      <View>
        <Grid container className={styles.container}>
          <Grid
            item
            container
            xs={12}
            className={clsx(styles.spacing)}
            direction={"row"}
          >
            <RouteLabel routeCode={routeCode} />
            {showVolume() && (
              <LocationVolumes
                locationCode={locationCode}
                routeCode={routeCode}
              />
            )}
          </Grid>
        </Grid>
      </View>
      {showArrow && (
        <View className={styles.arrowContainer}>
          <View className={styles.arrow} />
        </View>
      )}
    </Marker>
  );
});
